import { Router } from "@vaadin/router";
import "../maz-plushie/maz-plushie-gallery";
import "../maz-portals/maz-portals";
import "../maz-resourcepacks/maz-resourcepacks";
import "../maz-skins/maz-skins";
import "../maz-links/maz-links";

export const router = new Router(document.getElementById("outlet"));
router.setRoutes([
  { path: "/", component: "maz-plushie-gallery" },
  { path: "/plushies", component: "maz-plushie-gallery" },
  { 
    path: "/plushies/:theme",
    action: (context, commands) => {
      const element = document.createElement("maz-plushie-gallery");
      element.theme = context.params.theme as string;
      return element;
    }
  },
  { path: "/portals", component: "maz-portals" },
  { path: "/resourcepacks", component: "maz-resourcepacks" },
  { path: "/skins", component: "maz-skins" },
  { path: "/links", component: "maz-links" },
]);
